import { render } from "./priceDialog.vue?vue&type=template&id=4ed24177"
import script from "./priceDialog.vue?vue&type=script&lang=js"
export * from "./priceDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__